import React from "react";

import { subscriptionAgentCreditContent } from "../content/serviceCatalog";
import type { Locale } from "../content/types";

type PricingEstimatorSectionProps = {
  locale: Locale;
};

export function PricingEstimatorSection({ locale }: PricingEstimatorSectionProps) {
  const content = subscriptionAgentCreditContent[locale];

  return (
    <div className="pricing-estimator-section" aria-labelledby="subscription-credit-title">
      <div className="section-heading">
        <p className="section-eyebrow">{content.eyebrow}</p>
        <h3 id="subscription-credit-title">{content.title}</h3>
        <p>{content.lead}</p>
      </div>

      <div className="content-card-grid services-grid">
        {content.cards.map((card) => (
          <article className="content-card content-card--credit" data-credit-card={card.key} key={card.key}>
            <h3>{card.title}</h3>
            <p>{card.body}</p>
          </article>
        ))}
      </div>

      <section className="db-panel" aria-labelledby="subscription-credit-handoff-title">
        <h3 id="subscription-credit-handoff-title">{content.billingHandoffTitle}</h3>
        <p>{content.billingHandoffBody}</p>
        <p>{content.nonBindingNote}</p>
        <ul>
          {content.guardrails.map((guardrail) => (
            <li key={guardrail}>{guardrail}</li>
          ))}
        </ul>
      </section>
    </div>
  );
}
